import { CloseOutlined, Spacer, TextCapitalized } from "@qivia/ui";
import { HoursBarTripsOrPlanningVertical } from "@qivia/ui/src/designSystem/components/DayTripComponent/HoursBarTripsOrPlanningVertical";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import styled from "styled-components";
import { VehicleGeolocated } from "./index";
import { TripsDetails } from "../fleet/trips/tripsApi";

export const TripHistoryPanel = (props: {
  vehicle: VehicleGeolocated;
  trips: TripsDetails[];
  canRequestTripAddresses: boolean;
  onRequestTripAddresses: (tripUuid: string) => void;
  tripUuidWaitingForAddresses: string | null;
  onClose: () => void;
}) => {
  const {
    vehicle,
    trips,
    canRequestTripAddresses,
    onRequestTripAddresses,
    tripUuidWaitingForAddresses,
    onClose,
  } = props;
  const sortedTrips = [...trips].sort(
    (a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
  );

  return (
    <StyledPanel>
      <Spacer y={1} />
      <StyledFlex>
        <Spacer x={1} />
        <StyledTitle>
          <TextCapitalized>
            {`${vehicle.registrationNumber || "-"} · ${vehicle.driverName || "-"}`}
          </TextCapitalized>
        </StyledTitle>
        <StyledClose>
          <CloseOutlined onClick={onClose} />
        </StyledClose>
        <Spacer x={1} />
      </StyledFlex>
      <Spacer y={1} />
      <StyledContent>
        <HoursBarTripsOrPlanningVertical
          trips={sortedTrips}
          driverName={vehicle.driverName}
          plannings={[]}
          transactionsToDisplay={[]}
          tripUuidWaitingForAddresses={tripUuidWaitingForAddresses}
          canRequestTripAddresses={canRequestTripAddresses}
          onRequestTripAddresses={(trip) => onRequestTripAddresses(trip.uuid)}
          detailsPlacement="bottom"
        />
      </StyledContent>
    </StyledPanel>
  );
};

const StyledPanel = styled.div`
  position: fixed;
  top: 1.5rem;
  right: calc(25rem + 1.5rem);
  width: 25rem;
  height: 50vh;
  /* At least 5 hours of timeline (3rem per hour) plus the header */
  min-height: 19rem;
  display: flex;
  flex-direction: column;
  z-index: 1001;
  background-color: ${colors["colors/surfaces/background/background_level0"]};
  border: solid 0.0625rem ${colors["colors/borders/cells/cells"]};
  border-radius: 0.5rem;
`;

const StyledContent = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
`;

const StyledFlex = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyledTitle = styled.div`
  flex: 1;
`;

const StyledClose = styled.div`
  cursor: pointer;
`;
